// extracted by mini-css-extract-plugin
export default {"Title":"Contacts_Title__4r77J","Block":"Contacts_Block__gJGH1","Header":"Contacts_Header__hC-5A","Link":"Contacts_Link__bdRzJ"};